<template>
  <div class="video-wrap">
    <ul class="video-list">
      <li
        v-for="(video, index) in videos"
        :key="index"
        class="video-list__item"
      >
        <a :href="video.url" target="_blank" rel="noreferrer">
          <img :src="video.image" class="video-list__item-image" referrerpolicy="no-referrer">
          <i class="el-icon-caret-right video-list__item-icon"></i>
        </a>
      </li>
    </ul>

  </div>
</template>

<script>
  export default {
    name: 'VideoGallery',
    props: {
      videos: {
        type: Array
      }
    },
  };
</script>

<style>
  .video-wrap {
    background-color: #F5F7FA;
    margin-bottom: -20px;
    margin-top: 20px;
    width: 100%;
    box-sizing: border-box;
    /*padding: 15px 20px 10px 73px;*/
    padding: 10px 0;
  }
  .video-list {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
  }
  .video-list__item {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-right: 5px;
    width: 100px;
    height: 60px;
    overflow: hidden;
  }
  .video-list__item-image {
    position: absolute;
    left: 0;
    top: 0;
    width: 100px;
    z-index: 0;
    filter: blur(2px);
  }
  .video-list__item-icon {
    position: relative;
    color: #ff0000;
    font-size: 35px;
    z-index: 1;
  }
</style>
